import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import './style.scss';

export function FullWidthAnimation(props) {

  const animation = (
    <Player
      //alt='content-item'
      //className={props.className}
      loop
      autoplay
      controls
      src={props.animation}
    >
      <Controls visible={true} buttons={['play', 'stop']} />
    </Player>
  );
  return (
    <figure className='fullWidthAnimation'>
      {animation}
      <figcaption style={{display: (props.caption)?'initial':'none'}}>{props.caption}</figcaption>
    </figure>
  );
}

FullWidthAnimation.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  animation: PropTypes.string.isRequired,
  className: PropTypes.string,
  caption: PropTypes.string,
};
